'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'nav-glass' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2.5 group">
            <div className="flex items-center">
              <img
                src="https://campyellow-e8ldg07.public.builtwithrocket.new/_next/image?url=%2Fassets%2Fimages%2Fapp_logo.png&w=96&q=85"
                alt="Logo"
                width={36}
                height={36}
                className="flex-shrink-0"
              />
            </div>
            <span
              className="font-display font-800 text-lg tracking-tight text-foreground group-hover:text-accent transition-colors duration-300"
              style={{ fontFamily: '"DM Sans", sans-serif', fontWeight: 800 }}
            >
              Camp<span className="text-accent">Yellow</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {['Home', 'About', 'FAQ', 'Contact']?.map((item) => (
              <Link
                key={item}
                href={item === 'Home' ? '/' : `/${item?.toLowerCase()}`}
                className="text-sm font-600 transition-colors duration-200 relative group text-muted hover:text-foreground"
              >
                {item}
                <span className="absolute -bottom-1 left-0 h-0.5 bg-accent transition-all duration-300 w-0 group-hover:w-full" />
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <Link
              href="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent text-primary text-sm font-700 rounded-full hover:bg-accent-light transition-all duration-300 hover:-translate-y-0.5 accent-glow-sm"
              style={{ color: '#0d0d1a', fontWeight: 700 }}
            >
              Get in Touch
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden p-2 text-muted hover:text-foreground transition-colors"
            aria-label="Toggle menu"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
        style={{ background: 'rgba(13, 13, 26, 0.97)', backdropFilter: 'blur(16px)' }}
      >
        <div className="px-6 py-4 flex flex-col gap-1 border-t border-white/5">
          {['Home', 'About', 'FAQ', 'Contact']?.map((item) => (
            <Link
              key={item}
              href={item === 'Home' ? '/' : `/${item?.toLowerCase()}`}
              className="py-3 text-base font-600 transition-colors duration-200 border-b border-white/5 last:border-0 text-muted hover:text-foreground"
              onClick={() => setMobileOpen(false)}
            >
              {item}
            </Link>
          ))}
          <Link
            href="/contact"
            className="mt-3 inline-flex items-center justify-center gap-2 px-5 py-3 bg-accent text-primary text-sm font-700 rounded-full"
            style={{ color: '#0d0d1a', fontWeight: 700 }}
            onClick={() => setMobileOpen(false)}
          >
            Get in Touch
          </Link>
        </div>
      </div>
    </header>
  );
}
